import React, { useState } from "react";
import { Button } from "react-bootstrap";

interface Props {
  decryptionKey: String;
}

export function KeyDisplay({ decryptionKey }: Props) {
  const [showKey, setShowKey] = useState(false);

  // TODO: Use icons for the buttons?
  // TODO: Add some way to indicate that the text was copied.
  return (
    <div>
      {showKey ? (
        <div>0x{decryptionKey}</div>
      ) : (
        <div className="blur">
          0xca3704aa0b06f5954c79ee837faa152d84d6b2d42838f0637a15eda8337dbdce
        </div>
      )}
      <Button onClick={() => setShowKey(!showKey)}>Show</Button>
      <Button
        onClick={() => navigator.clipboard.writeText(`0x${decryptionKey}`)}
      >
        Copy
      </Button>
    </div>
  );
}
